import cognitoAuth from '@/cognito'
import { SESClient, SendEmailCommand } from '@aws-sdk/client-ses'
import { fromCognitoIdentityPool } from '@aws-sdk/credential-providers'
import { escapeHtml } from '@/utils/sanitize'
import brand from '@/composables/useBrand'
import { buildInvitationEmail } from '@/ses/templates/invitationEmail'

export default class SES {
  async _getSESClient () {
    const logins = {}
    logins['cognito-idp.' + process.env.VUE_APP_AWS_REGION + '.amazonaws.com/' + process.env.VUE_APP_COGNITO_USER_POOL_ID] = await cognitoAuth.getIdTokenPromise()
    const credentials = fromCognitoIdentityPool({
      clientConfig: { region: process.env.VUE_APP_AWS_REGION },
      identityPoolId: process.env.VUE_APP_COGNITO_IDENTITY_POOL_ID,
      logins
    })
    return new SESClient({ region: process.env.VUE_APP_AWS_REGION, credentials })
  }

  async _send ({ recipientEmail, subject, html, text, senderEmail = brand.emails.support }) {
    const client = await this._getSESClient()
    const command = new SendEmailCommand({
      Destination: { ToAddresses: [recipientEmail] },
      Message: {
        Body: {
          Html: { Charset: 'UTF-8', Data: html },
          Text: { Charset: 'UTF-8', Data: text }
        },
        Subject: { Charset: 'UTF-8', Data: subject }
      },
      Source: senderEmail,
      ReplyToAddresses: [senderEmail]
    })

    await client.send(command)
  }

  async sendAdminEmail (recipientEmail, content, senderEmail = brand.emails.support, subject = `Message from ${brand.name} Support`) {
    const htmlContent = escapeHtml(content).replace(/\n/g, '<br>')

    await this._send({
      recipientEmail,
      subject,
      senderEmail,
      html: `<div style="font-family: Arial, sans-serif; font-size: 14px; line-height: 1.6;">${htmlContent}</div>`,
      text: content
    })
  }

  async sendEmail (recipientEmail, project, senderName, workflowName = null, { isRegistered = true, isSeated = false } = {}) {
    const { subject, html, text } = buildInvitationEmail({
      brand,
      project,
      senderName,
      recipientEmail,
      workflowName,
      origin: window.location.origin,
      isRegistered,
      isSeated
    })

    await this._send({ recipientEmail, subject, html, text })
  }
}
